import request from '@/utils/util.request';
/**
 * @desc (tts) 创建TTS页面加载
 */
export const tts_load_data = (data) => {
	return request({
		url: '/tts/loaddata',
		data,
	});
};
/**
 * @decs (tts) 创建TTS页面创建
 * @param {string} words
 * @param {int} times
 * @param {string} voice
 */
export const tts_submit = (data) => {
	return request({
		url: '/tts/submit',
		data,
	});
};
